import { AccountItemBlock } from "./AccountItem";
import PimsExportFormatSetting from "./PimsExportFormatSetting";
import PimsProviderSetting from "./PimsProviderSetting";

export default function PimsExportingSettings() {
  return (
    <div className="flex-1 flex flex-col gap-md">
      <div className="flex flex-col space-y-4 divide-y divide-secondary">
        <AccountItemBlock
          title="Your PIMS:"
          desc="Select the practice management software you use. This helps us tailor your export experience."
        >
          <PimsProviderSetting />
        </AccountItemBlock>
        <AccountItemBlock
          title="Export Format:"
          desc="Choose the format used when exporting notes to your PIMS. The best option depends on how your PIMS handles pasted text."
        >
          <PimsExportFormatSetting />
        </AccountItemBlock>
      </div>
    </div>
  );
}
